import React, { Component } from 'react';
import { Button, Row, Card } from 'react-bootstrap'

class OrderCompleted extends Component {
    state = {
        paymentSuccess: false,
        paymentCancell: false,
    }
    closePaymentSuccess = () => {
        this.setState({ paymentSuccess: false })
    }
    closePaymentCancel = () => {
        this.setState({ paymentCancell: false })
    }
    componentDidMount() {
        this.paymentSuccessOrFail()

    }
    paymentSuccessOrFail = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const price = urlParams.get('price');
        const payment = urlParams.get('payment');
        if (payment) {
            if (payment === 'true') {
                // window.gtag_report_conversion_purchased(price)
                this.setState({ paymentSuccess: true })
            }
            else {
                this.setState({ paymentCancell: true })
            }
        }
    }
    render() {
        return (
            <div>
                {this.state.paymentSuccess &&
                    <Row style={{ margin: '20px' }}>
                        <Card style={{ width: '100%', maxWidth: '1000px', margin: 'auto', backgroundColor: 'rgb(75,181,67)' }}>
                            <div style={{ position: 'absolute', top: '25%', left: '96%', transform: 'translate(-50%, -50%)' }}>
                                <div style={{ width: '30px', height: '30px', backgroundColor: 'rgba(0,0,0,0.2)', textAlign: 'center' }} onClick={this.closePaymentSuccess} ><p style={{ color: 'black' }}>x</p></div>
                            </div>
                            <h3 style={{ textAlign: 'center' }}>Payment Success.</h3>
                            <h5 style={{ textAlign: 'center' }}>Your new subscription should be shown below. Click refresh if subscription not shown.</h5>
                        </Card>
                    </Row>}
                {this.state.paymentCancell &&
                    <Row style={{ margin: '20px' }}>
                        <Card style={{ width: '100%', maxWidth: '1000px', margin: 'auto', backgroundColor: 'rgb(255,69,0)' }}>
                            <div style={{ position: 'absolute', top: '25%', left: '96%', transform: 'translate(-50%, -50%)' }}>
                                <div style={{ width: '30px', height: '30px', backgroundColor: 'rgba(0,0,0,0.2)', textAlign: 'center' }} onClick={this.closePaymentCancel} ><p style={{ color: 'black' }}>x</p></div>
                            </div>
                            <h3 style={{ textAlign: 'center' }}>Payment Cancelled.</h3>
                            <h5 style={{ textAlign: 'center' }}>Please try again.</h5>
                        </Card>
                    </Row>}
            </div>
        );
    }
}

export default OrderCompleted;